import { useMemo } from "react";
import Svg from "e.sic-platform.webclient/src/components/svg/Svg";
import { Cameraswitch, ShoppingCart } from "@mui/icons-material";
import useThemeService from 'e.sic-platform.webclient/src/services/theme-service/ThemeService';
import { useTheme } from "@mui/material";
import { Detection, RunAI, SmartManagerWhite } from "e.sic-platform.webclient/src/components/svg/svgImageList";

export interface MainMenuItemCategory {
  name: string;
  canAccess: boolean;
  path?: string;
  aliases?: string[];
  icon: any;
  iconSelected: any;
  hide?: boolean;
}

export default function useMenuStorage() {
  const { themeClass } = useThemeService();
  const {palette} = useTheme();
  
  const menuCategories: MainMenuItemCategory[] = useMemo(
    () => [
        {
          name: "video-conversion",
          path: "/video-conversion", 
          icon: (<Svg svg={Cameraswitch} style={{padding: "15px", color: "white"}}/>),
          iconSelected: (<Svg svg={Cameraswitch} style={{padding: "15px", color: palette.primary.light}}/>),
          canAccess: true
        },
        {
          name: "video-analysis", 
          path: "/video-analysis", 
          icon: (<Svg svg={RunAI} className={themeClass(["icon-custom"])}/>),
          iconSelected: (<Svg svg={RunAI} className={themeClass(["icon-custom-main"])}/>),
          canAccess: true
        },
        {
          name: "video-segmentation", 
          path: "/video-segmentation", 
          icon: (<Svg svg={Detection} className={themeClass(["icon-custom"])}/>),
          iconSelected: (<Svg svg={Detection} className={themeClass(["icon-custom-main"])}/>),
          canAccess: true
        },
        {
          name: "shop", 
          path: "/shop", 
          icon: (<Svg svg={ShoppingCart} style={{padding: "15px", color: "white"}}/>),
          iconSelected: (<Svg svg={ShoppingCart} style={{padding: "15px", color: palette.primary.light}}/>),
          canAccess: true
        },
        {
          name: "shop-history",
          path: "app-usage",
          canAccess: true,
          icon: (<></>),
          iconSelected: (<></>),
          hide: true
        },
        {
          withDivider: true, 
          name: "smart-manager", 
          path: JSON.parse(sessionStorage["config-storage"]).platform_url, 
          icon: (<Svg svg={SmartManagerWhite} className={themeClass(["icon-custom-logo"])}/>),
          iconSelected: (<Svg svg={SmartManagerWhite} className={themeClass(["icon-custom-logo"])}/>),
          canAccess: true
        }
    ],
    []
  );

  return { menuCategories };
}
